
export const initialStates = {
  createEvent: {
    nombre_organizador: '',
    celular_principal: '',
    celular_secundario: '',
    nombre: '',
    descripcion: '',
    ciudad: '',
    estado: '',
    ubicacioni: '',
    direccion: '',
    latitud: '',
    longitud: '',
    foto_portada: '',
    video: '',
    divisa: '',
    fecha_actualizado: '',
    categorias: [],
    tipo_cobro: false,
    habra_boletos: false,
    metodos_pago: [],
    boletos: [],
    acepto_terminos: false
  }
}
